import { render, staticRenderFns } from "./task-component.vue?vue&type=template&id=54c4db8a"
import script from "./task-component.vue?vue&type=script&lang=ts"
export * from "./task-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports